import { render } from 'react-dom';
import { Router, Route, Switch } from 'react-router-dom';
import createHistory from 'history/createBrowserHistory';
import DevTools from 'mobx-react-devtools';
import React from 'react';
import { unregister } from './registerServiceWorker';

import './langs/';
import './index.css';
import './utils/Format';

import App from './components/App';
import Login from './components/Login';
import Register from './components/Register';
import Candidato from './components/candidato';
import Rodada from './components/rodada';
import Municipio from './components/municipio';
import Usuario from './components/usuario';
import Apresentacao from './components/apresentacao';
import ProporcionalDistribuicao from './components/proporcional/distribuicao';
import ProporcionalIndecisos from './components/proporcional/indecisos';
import ProporcionalIntencao from './components/proporcional/intencao';
import ProporcionalVagas from './components/proporcional/vagas';
import ProporcionalVotacao from './components/proporcional/votacao';
import MajoritarioEspontaneo from './components/majoritario/espontaneo';
import MajoritarioEstimulado from './components/majoritario/estimulado';
import MajoritarioIndecisos from './components/majoritario/indecisos';
import MajoritarioProjecao from './components/majoritario/projecao';
import MajoritarioRelatorio from './components/majoritario/relatorio';
import MajoritarioValidos from './components/majoritario/validos';
import Mapas from './components/mapas';

export const history = createHistory();

render(
  <div>
    <Router history={history}>
      <Switch>
        <Route path="/login" component={Login} />
        <Route path="/register" component={Register} />
        <App>
          <Route exact path="/candidatos" component={Candidato} />
          <Route exact path="/rodadas" component={Rodada} />
          <Route exact path="/municipios" component={Municipio} />
          <Route exact path="/usuarios" component={Usuario} />

          <Route exact path="/" component={Apresentacao} />

          <Route
            exact
            path="/proporcional/vagas"
            component={ProporcionalVagas}
          />
          <Route
            exact
            path="/proporcional/distribuicao"
            component={ProporcionalDistribuicao}
          />
          <Route
            exact
            path="/proporcional/indecisos"
            component={ProporcionalIndecisos}
          />
          <Route
            exact
            path="/proporcional/intencao"
            component={ProporcionalIntencao}
          />
          <Route
            exact
            path="/proporcional/votacao"
            component={ProporcionalVotacao}
          />

          <Route
            exact
            path="/majoritario/espontaneo"
            component={MajoritarioEspontaneo}
          />
          <Route
            exact
            path="/majoritario/estimulado"
            component={MajoritarioEstimulado}
          />
          <Route
            exact
            path="/majoritario/validos"
            component={MajoritarioValidos}
          />
          <Route
            exact
            path="/majoritario/projecao"
            component={MajoritarioProjecao}
          />
          <Route
            exact
            path="/majoritario/relatorio"
            component={MajoritarioRelatorio}
          />
          <Route
            exact
            path="/majoritario/indecisos"
            component={MajoritarioIndecisos}
          />

          <Route exact path="/mapas/:tipo" component={Mapas} />
        </App>
      </Switch>
    </Router>
    {process.env.NODE_ENV !== 'production' ? (
      <DevTools position={{ bottom: 0, left: 0 }} />
    ) : (
      ''
    )}
  </div>,
  document.getElementById('root')
);
unregister();



// WEBPACK FOOTER //
// ./src/index.js